module.exports = __webpack_public_path__ + "img/payment_failed.7f3a5396.svg";